import { Box, Divider, VStack, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React from 'react';
import { DanIcon } from '../icons/Icons';

export const GeneratorHeader: React.FC = () => {
  const router = useRouter();
  return (
    <VStack w="full">
      <Box w="full" position="relative" pl="26px" pt="22px" pb={4} pr={{base: '26px', sm: 0}}>
        <Flex justifyContent="center">
          <DanIcon w={12} h={12} cursor="pointer" onClick={() => router.push('/results')} />
        </Flex>
      </Box>
      <Divider w="full" />
    </VStack>
  );
};
